let mmenu;

import 'mmenu-light/dist/mmenu-light.css'
import 'mmenu-light/dist/mmenu-light.js'

document.addEventListener("DOMContentLoaded", () => {
  const menuElement = document.querySelector("#menu");
  const menu = new MmenuLight(menuElement, "(max-width: 1199px)");
  const navigator = menu.navigation({
    title: "Menü"
  });
  const drawer = menu.offcanvas();

  // Footer-Navigation als eigenes Element einfügen
  const footer = document.createElement("div");
  footer.classList.add("mm-footer");
  footer.innerHTML = `
    <a href="/ueber-uns/karriere" title="Karriere" class="button button--career"><i class="icon-career"></i>Karriere</a>
    <a href="/spenden" title="Deine Spende verbindet Menschen." class="button button--donate"><i class="icon-donate"></i>Spenden</a>
  `;

  menuElement.appendChild(footer);

  // Menü öffnen/schließen
  document.querySelector(".js-toggle-menu")
    .addEventListener("click", (evnt) => {
      evnt.preventDefault();

      if (document.body.classList.contains('mm-ocd-opened')) {
        drawer.close();
      } else {
        drawer.open();
      }
    });
});

export default mmenu;